/**
 * state.js
 * Quản lý trạng thái ứng dụng tập trung (Single Source of Truth) cho Voxel Anim Studio.
 */

import { CharacterManager } from '../studio/character-manager.js';
import { EmotionEffectsManager } from '../studio/emotion-effects.js';
import { ProjectManager } from '../studio/project-manager.js';
import { VietnamCityBuilder } from '../city/vietnam-city.js';
import { SPECIES_IGNIS } from '../avatars/avatar-presets.js';

export const characterManager = new CharacterManager();
export const emotionEffectsManager = new EmotionEffectsManager();
export const projectManager = new ProjectManager();
export const cityBuilder = new VietnamCityBuilder();

export const state = {
  // Three.js Core
  scene: null,
  camera: null,
  renderer: null,
  controls: null,
  clock: null,

  // Ánh sáng & Sân khấu Studio
  ambientLight: null,
  keyLight: null,
  fillLight: null,
  backLight: null,
  streetLight1: null,
  streetLight2: null,
  studioEnvironmentGroup: null,
  pedestalGroup: null,
  gridHelper: null,

  // Managers
  characterManager,
  emotionEffectsManager,
  projectManager,
  cityBuilder,

  // Chế độ & Avatar Studio
  currentMode: 'studio',
  currentPresetKey: 'TEACHER',
  currentAction: 'idle',
  isArticulatedRig: true,
  activeCustomProps: { isArticulated: true },
  activeAvatars: [],
  mainAvatar: null,
  secondaryAvatars: [],

  // Kịch bản & Đạo diễn Storyboard
  currentProject: projectManager.loadDraft() || projectManager.createDefaultProject(),
  storyboardDirector: null,
  currentShotIndex: 0,
  videoRecorder: null,

  // Chế độ Kịch bản Phố Phường (Street Drama)
  dramaDirector: null,
  isDramaSubtitleEnabled: false,
  movingVehicles: [],
  cityGroup: null,

  // Chế độ Động vật 3D (Animals Mode)
  currentAnimal: null,
  currentAnimalSpecies: 'DOG',
  currentAnimalVariant: 'shiba',
  currentAnimalAnim: 'idle',
  currentAnimalScale: 1.0,

  // Chế độ Phòng thí nghiệm & NPC đi dạo (Lab & Walker)
  labBenchGroup: null,
  labItems: [],

  // Quần thể dân cư bản địa (Demographics)
  currentPopulationSpecies: SPECIES_IGNIS,
  currentPopGender: 'male',
  currentPopAge: 'adult',
  currentPopColorIndex: 0,

  // Giao diện
  currentSubTab: 'presets'
};
